import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  sessionId: string;
}

export function useDeleteSession() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ sessionId }: Params) => del({ url: `/user/account/sessions/${sessionId}` }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.getSessions });
    },
  });

  const deleteSession = useCallback((params: Params) => mutate(params), [mutate]);

  return { deleteSession, error, isPending, isSuccess, reset };
}
